import axios from "axios";

export async function uploadFiles(client, selected_files, user) {
    console.log("in helpers/ upload files")
    console.log(client, user)
    console.log(selected_files)

    let headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        client: this.client,
    }
    if (user != null) {
        headers.Authorization = "Bearer " + user.access_token
    }

    let formData = new FormData();
    formData.append("client", client);
    // formData.append("selectedfile", selected_files[0].file);
    selected_files.forEach((item) => {
        formData.append("selectedfile[]", item.file);
    });

    let ids = []
    await axios
        .post("filesmodule/upload", formData, {
            headers: headers
        })
        .then((response) => {
            console.log(response);
            console.log(response.data);
            //this.is_loading = false;

            for (let i = 0; i < response.data.length; i++) {
                ids.push(response.data[i].id)
            }
            console.log(ids)

        })
        .catch((error) => {
            console.log(error);
            this.$fire({
                // title: "Title",
                text: error,
                type: "error",
                timer: 5000,
                customClass: {
                    container: this.swal_container_class,
                    confirmButton: this.swal_confirm_button_class,
                },
            }).then((r) => {
                // console.log(r.value);
            });
        });
    return ids;
}

// import CancelToken from 'axios/lib/cancel/CancelToken'
//'axios/lib/CancelToken';
// const CancelToken = axios.CancelToken;


export function uploadFilesWithCancel(client, selected_files, user, swal_container_class, swal_confirm_button_class) {
    console.log("in helpers/ upload files cancel token")
    console.log(client, user)
    console.log(selected_files)

    // const cancelTokenSource = CancelToken.source();

    const controller = new AbortController();
    const signal = controller.signal;

    let headers = {
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
        client: this.client,
    }
    if (user != null) {
        headers.Authorization = "Bearer " + user.access_token
    }

    let formData = new FormData();
    formData.append("client", client);
    // formData.append("selectedfile", selected_files[0].file);
    selected_files.forEach((item) => {
        formData.append("selectedfile[]", item.file);
    });

    let ids = []
    const request = axios
        .post("filesmodule/upload", formData, {
            headers: headers,
            signal: signal,

            onUploadProgress: function (progressEvent) {
                console.log("--------", progressEvent.loaded,
                    progressEvent.total,
                    (progressEvent.loaded / progressEvent.total) * 100);
            }
            // cancelToken: cancelTokenSource//.token
        })
        .then((response) => {
            console.log(response);
            console.log(response.data);
            let response_data = response.data
            //this.is_loading = false;

            for (let i = 0; i < response_data.length; i++) {
                ids.push(response_data[i].id)
            }
            console.log(ids)

            

            return { ids, response_data }

        })
        .catch((error) => {
            console.log(error);
            let error_message = ""
            if (error.message) {
                error_message = error.message == 'canceled' ? this.$t('cancel_request_msg') : error.message
            } else {
                error_message = error
            }
            this.$fire({
                // title: "Title",
                text: error_message,
                type: "error",
                // timer: 5000,
                customClass: {
                    container: swal_container_class,
                    confirmButton: swal_confirm_button_class,
                },
            }).then((r) => {
                // console.log(r.value);
            });
        });
    // return cancelTokenSource;
    return { request, controller }
}


// WEBPACK FOOTER //
// ./src/utils/upload-files.js